module.exports = __webpack_public_path__ + "img/slogan.f75aa099.png";